/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityScreenerSettingsEntry } from './FacilityScreenerSettingsEntry';
import {
    FacilityScreenerSettingsEntryFromJSON,
    FacilityScreenerSettingsEntryFromJSONTyped,
    FacilityScreenerSettingsEntryToJSON,
    FacilityScreenerSettingsEntryToJSONTyped,
} from './FacilityScreenerSettingsEntry';

/**
 * 
 * @export
 * @interface GetFacilityScreenerSettings200Response
 */
export interface GetFacilityScreenerSettings200Response {
    /**
     * 
     */
    data: Array<FacilityScreenerSettingsEntry>;
}

/**
 * Check if a given object implements the GetFacilityScreenerSettings200Response interface.
 */
export function instanceOfGetFacilityScreenerSettings200Response(value: object): value is GetFacilityScreenerSettings200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function GetFacilityScreenerSettings200ResponseFromJSON(json: any): GetFacilityScreenerSettings200Response {
    return GetFacilityScreenerSettings200ResponseFromJSONTyped(json, false);
}

export function GetFacilityScreenerSettings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFacilityScreenerSettings200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(FacilityScreenerSettingsEntryFromJSON)),
    };
}

export function GetFacilityScreenerSettings200ResponseToJSON(json: any): GetFacilityScreenerSettings200Response {
    return GetFacilityScreenerSettings200ResponseToJSONTyped(json, false);
}

export function GetFacilityScreenerSettings200ResponseToJSONTyped(value?: GetFacilityScreenerSettings200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(FacilityScreenerSettingsEntryToJSON)),
    };
}

